export default __webpack_public_path__ + "static/media/img_si_more_m.a058771d.webp";